module.exports = __webpack_public_path__ + "static/img/message.e4ed4f9f.svg";